import { Drug } from '../types/drug.ts';
import { SaldoThresholds } from '../types/saldoThresholds.ts';

interface DrugWithDetails {
    drug: Drug;
    quantityRemaining: number;
    saldoThresholds: SaldoThresholds;
}

interface DrugsInStorageSlice {
    drugsInStorage: DrugWithDetails[];
    setDrugsInStorage: (drugsInStorage: DrugWithDetails[]) => void;
    addDrug: (drugWithDetails: DrugWithDetails) => void;
    removeDrug: (id: string) => void;
    updateDrug: (updatedDrugWithDetails: DrugWithDetails) => void;
    resetDrugsInStorage: () => void;
}

const createDrugsInStorageSlice = (set: any) => ({
    drugsInStorage: [] as DrugWithDetails[],

    setDrugsInStorage: (drugsInStorage: DrugWithDetails[]) =>
        set({ drugsInStorage }),

    addDrug: (drugWithDetails: DrugWithDetails) =>
        set((state: DrugsInStorageSlice) => ({
            drugsInStorage: [...state.drugsInStorage, drugWithDetails],
        })),

    removeDrug: (id: string) =>
        set((state: DrugsInStorageSlice) => ({
            drugsInStorage: state.drugsInStorage.filter(
                (item) => item.drug.id !== id
            ),
        })),

    updateDrug: (updatedDrugWithDetails: DrugWithDetails) =>
        set((state: DrugsInStorageSlice) => ({
            drugsInStorage: state.drugsInStorage.map((item) =>
                item.drug.id === updatedDrugWithDetails.drug.id
                    ? updatedDrugWithDetails
                    : item
            ),
        })),

    resetDrugsInStorage: () => set({ drugsInStorage: [] }),
});

export { createDrugsInStorageSlice };
export type { DrugsInStorageSlice, DrugWithDetails, Drug, SaldoThresholds };
